/**
 * LBR2-D2 careers-page — branded public chrome (header + footer).
 *
 * Deliberately self-contained: imports ONLY react-router `Link` + lucide icons.
 * It does NOT import AppShell / auth store / sidebar so the careers pages can
 * lift to a standalone host (jobs.sunstellar.in) with only a routing change.
 */
import { Link } from 'react-router-dom';
import { UserCircle2 } from 'lucide-react';

export function CareersChrome({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen flex-col bg-[#faf8f4]">
      <header className="border-b border-gray-200 bg-white/80 backdrop-blur">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3">
          <Link to="/jobopenings" className="flex items-center gap-2">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-[#f5870a] text-lg font-bold text-white shadow">
              A
            </span>
            <span className="font-display text-lg font-bold text-gray-900">Careers</span>
          </Link>
          <Link
            to="/jobopenings/account"
            className="flex items-center gap-1.5 rounded-lg px-3 py-1.5 text-sm font-semibold text-gray-700 hover:bg-gray-100"
          >
            <UserCircle2 className="h-4 w-4" /> My account
          </Link>
        </div>
      </header>
      <main className="mx-auto w-full max-w-4xl flex-1 px-4 py-6">{children}</main>
      <footer className="py-6 text-center text-xs text-gray-400">
        Powered by AURA · Ardhanex Tech
      </footer>
    </div>
  );
}

export default CareersChrome;
